








import { defineComponent, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import ApplicationTab from '@/components/feature/PDP/ApplicationTab.vue'
import { useProductStore } from '~/store/product'
import { usePdpStore } from '~/store/pdp'

export default defineComponent({
  components: { ApplicationTab },
  setup() {
    const productStore = useProductStore()
    const pdpStore = usePdpStore()
    const { selectedApplication } = storeToRefs(usePdpStore())
    const applicationChiclets = computed(() => {
      return productStore.getChicletsForApplicationTab(productStore.currentProduct.data.key)
    })

    function setSelectedChiclet(application: string | null) {
      if (application) {
        if (application === 'other') {
          pdpStore.setSelectedApplication({
            group: application,
          })
        } else {
          const currentApplication =
            productStore.currentProduct.data.attributes.lots?.lot.applications?.application.find(
              (a) => a.codeForDisplay === application
            )
          const currProtocolNo = currentApplication?.protocol?.number
          const currProtocol = currProtocolNo
            ? productStore.currentProduct.data.attributes.protocols?.[currProtocolNo]
            : undefined
          pdpStore.setSelectedApplication({
            code: currentApplication?.code,
            group: currentApplication?.codeForDisplay,
            protocolId: currProtocol?.number,
          })
        }
      } else {
        pdpStore.unsetSelectedApplication()
      }
    }

    return { applicationChiclets, setSelectedChiclet, selectedApplication }
  },
})
